/**
 * 获取url中参数
 * @param {*} name  参数key值
 * @returns 
 */
export const getQueryString = function (variable) {
  let href = window.location.href
  let query = href.substring(href.indexOf('?') + 1)
  let vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return null
}
/**
 * 时间格式化
 * @param {*} date 
 * @param {*} format  yyyy-MM-dd hh:mm:ss.S  yyyy-M-d h:m:s.S
 */
export const dateFormat = (date, fmt) => {
  const time = new Date(date)
  let o = {
    'M+': time.getMonth() + 1, // 月份
    'd+': time.getDate(), // 日
    'h+': time.getHours(), // 小时
    'm+': time.getMinutes(), // 分
    's+': time.getSeconds(), // 秒
    'q+': Math.floor((time.getMonth() + 3) / 3), // 季度
    S: time.getMilliseconds() // 毫秒
  }
  // 年
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (time.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length) // 如果两位补0
      )
    }
  }
  return fmt
}
// 判断是否为空
export const _isEmpty = function (params) {
  if (params === "" || params === undefined || params === null) {
    return true;
  }
  return false;
};
// 判断是否为对象
export const _isObj = function (obj) {
  return Object.prototype.toString.call(obj) === '[Object Object]'
}
// 判断是否为字符串
export const _isString = function (str) {
  return (typeof str == 'string') && str.constructor == String;
}
// 判断是否为字符串
export const _isArray = function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
}
// 将时间转为全时间格式，如2020-1
export const _completeTime = function (params, isStart) {
  if (!params) return params
  // 如果参数为字符串，且isStart为true，认为其是开始时间，否则为结束时间
  if (_isString(params)) {
    const regex = /(\d+-\d+-\d+)(\s+)(\d+:\d+:\d+)/
    if (!regex.test(params)) {
      if (isStart) return params + ' 00:00:00'
      return params + ' 23:59:59'
    }
  }
  // 如果参数为数组，则长度必须为两位，一位是开始时间，一位是结束时间
  if (_isArray(params)) {
    const dataStr = []
    if (params.length === 2) {
      const regex = /(\d+-\d+-\d+)(\s+)(\d+:\d+:\d+)/
      dataStr[0] = params[0]
      dataStr[1] = params[1]
      if (!regex.test(params[0])) {
        dataStr[0] = params[0].replace(/(\d+-\d+-\d+)/, '$1 00:00:00')
      }
      if (!regex.test(params[1])) {
        dataStr[1] = params[1].replace(/(\d+-\d+-\d+)/, '$1 23:59:59')
      }
      return dataStr
    }
  }
  return params
}
export const viewFitConfig = {
  viewThreshold: 1024, // pc 、m站切换的阈值
  mWidth: 375, // m端-设计稿宽度
  pcWidth: 1920, // pc端-设计稿宽度
}
// 获得当前终端类型
export const getTerminal = () => {
  const u = navigator.userAgent
  return {
    trident: u.includes('Trident'), // IE内核
    presto: u.includes('Presto'), // opera内核
    webKit: u.includes('AppleWebKit'), // 苹果、谷歌内核
    gecko: u.includes('Gecko') && !u.includes('KHTML'), // 火狐内核
    mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
    ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
    android: u.includes('Android') || u.includes('Adr'), // android终端
    iPhone: u.includes('iPhone'), // 是否为iPhone或者QQHD浏览器
    iPad: u.includes('iPad'), // 是否iPad
    webApp: !u.includes('Safari'), // 是否web应该程序，没有头部与底部
    weixin: u.includes('MicroMessenger'), // 是否微信
    qq: u.match(/\sQQ/i) === ' qq', // 是否QQ
  }
}
/**
 * 判断用户代理是否为 Mobile
 * @param {String} ua
 * @returns {Boolean}
 */
export const _isMobile = (ua) => {
  return !!ua.match(/AppleWebKit.*Mobile.*/) // 是否为移动终端
}
// 获得当前页面类型
export const getTerminalPage = () => {
  const width = document.body.clientWidth
  const terminal = getTerminal()
  return width < viewFitConfig.viewThreshold || terminal.mobile
    ? 'mobile'
    : 'pc'
}
// 获取路由参数
export const _getQueryString = variable => {
  let href = window.location.href
  let query = href.substring(href.indexOf('?') + 1)
  let vars = query.split('&')
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}
// 判断浏览器语言
export const _browserLanguage = (isChinese) => {
  const language = (
    navigator.browserLanguage || navigator.language
  ).toLowerCase();
  if (isChinese) {
    return language.indexOf("zh") > -1;
  } else {
    if (language.indexOf("zh") > -1) {
      return "zh";
    } else if (language.indexOf("en") > -1) {
      return "en";
    } else {
      return "other";
    }
  }
}


/**
 * iframe 向父窗口发送信息
 * { type,  value} = paramObject
 * @param {*} paramObject
 */
export const postMessageToParent = paramObject => {
  parent.postMessage(paramObject, '*')
}

/**
 * 父窗口向子窗口发送消息
 * @param {*} body  { type: '类型'，value： '值'  }
 */
export const postMessageToSub = (iframe, paramObject) => {
  iframe && iframe.contentWindow.postMessage(paramObject, '*')
}
/**
 * iframe消息监听
 * @param {*} handler 
 */
export const iframeListener = handler => {
  if (typeof window.addEventListener !== 'undefined') {
    window.addEventListener('message', handler, false)
  } else if (typeof window.attachEvent !== 'undefined') {
    window.attachEvent('onmessage', handler)
  }
}
/**
 * iframe 向父窗口发送路由信息，内部系统跳转时调用
 * { type,  value} = paramObject
 * @param {*} paramObject
 */
export const postRouteToParent = paramObject => {
  if (!paramObject || !paramObject.basePath || !paramObject.menuName || !paramObject.menuPath) {
    return false
  }
  const obj = {
    type: 'breadcrumb',
    menuPath: `${location.origin}${paramObject.menuPath}`,
    menuName: paramObject.menuName,
    basePath: `${location.origin}${paramObject.basePath}`
  }
  postMessageToParent(obj)
}

/**
 * iframe 向父窗口发送路由信息, 跳转外部系统时调用
 * { type,  ...} = paramObject
 * @param {*} paramObject
 */
export const postRouteToParentNew = paramObject => {
  if (!paramObject || !paramObject.basePath || !paramObject.menuName || !paramObject.menuPath || !paramObject.systemId) {
    return false
  }
  const obj = {
    type: 'breadcrumb',
    menuPath: `${paramObject.menuPath}`,
    menuName: paramObject.menuName,
    basePath: `${paramObject.basePath}`,
    systemId: paramObject.systemId
  }
  postMessageToParent(obj)
}


/**
 * 加法运算，避免数据相加小数点后产生多位数和计算精度损失。
 * 
 * @param num1加数1 | num2加数2
 */
export const _numAdd = function (num1, num2) {
  let baseNum, baseNum1, baseNum2;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
};
/**
 * 加法运算，避免数据相减小数点后产生多位数和计算精度损失。
 * 
 * @param num1被减数  |  num2减数
 */
export const _numSub = function (num1, num2) {
  let baseNum, baseNum1, baseNum2;
  let precision;// 精度
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  precision = (baseNum1 >= baseNum2) ? baseNum1 : baseNum2;
  return ((num1 * baseNum - num2 * baseNum) / baseNum).toFixed(precision);
};
/**
 * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。
 * 
 * @param num1被乘数 | num2乘数
 */
export const _numMulti = function (num1, num2) {
  let baseNum = 0;
  try {
    baseNum += num1.toString().split(".")[1].length;
  } catch (e) {
  }
  try {
    baseNum += num2.toString().split(".")[1].length;
  } catch (e) {
  }
  return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum);
};
/**
 * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。
 * 
 * @param num1被除数 | num2除数
 */
export const _numDiv = function (num1, num2, fixedNum) {
  let baseNum1 = 0, baseNum2 = 0;
  let baseNum3, baseNum4;
  try {
    baseNum1 = num1.toString().split(".")[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split(".")[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum3 = Number(num1.toString().replace(".", ""));
  baseNum4 = Number(num2.toString().replace(".", ""));
  return ((baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1)).toFixed(fixedNum || 2);
}
// 向当前元素末尾追加一个元素
export const append = function (newEle, container) {
  container.appendChild(newEle);
}
// 向当前元素之前追加一个元素
export const prepend = function (newEle, container) {
  var firstEle = this.firstChild(container);
  if (firstEle) {
    container.insertBefore(newEle, firstEle);
    return;
  }
  this.append(newEle, container);
}
//添加class
export const addClass = function (obj, sClass) {
  var aClass = obj.className.split(' ');
  if (!obj.className) {
    obj.className = sClass; return;
  }
  for (var i = 0; i < aClass.length; i++) {
    if (aClass[i] === sClass) return;
  }
  obj.className += ' ' + sClass;
}
export const debounce = function (fn, wait = 50, immediate) {
  let timer = null
  return function (...args) {
    if (timer) clearTimeout(timer)
    // ------ 新增部分 start ------ 
    // immediate 为 true 表示第一次触发后执行
    // timer 为空表示首次触发
    if (immediate && !timer) {
      fn.apply(this, args)
    }
    // ------ 新增部分 end ------ 
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, wait)
  }
}
//移除class
export const removeClass = function (obj, sClass) {
  var aClass = obj.className.split(' ');
  if (!obj.className) return;
  for (var i = 0; i < aClass.length; i++) {
    if (aClass[i] === sClass) {
      aClass.splice(i, 1);
      obj.className = aClass.join(' ');
      break;
    }
  }
}

export const setCookie = function(name, value, day = 30) {
  const exp = new Date();
  exp.setTime(exp.getTime() + day * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(
    value.toString()
  )};path=/;expires=${exp.toUTCString()}`;
}

export const getCookie = function(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return decodeURIComponent(arr[2]);
  }
  return null;
}

export const removeCookie = function(name)  {
  if (!name) return;
  const ex = new Date();
  ex.setTime(ex.getTime() - 1);
  document.cookie = `${name}=; expires=${ex.toUTCString()};path=/`;
}
export const clearCookie = function (params) {
  setCookie('', '', -1)
}

export const Base64 = function() {
  var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  this.encode = function(input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      input = _utf8_encode(input);
      while (i < input.length) {
          chr1 = input.charCodeAt(i++);
          chr2 = input.charCodeAt(i++);
          chr3 = input.charCodeAt(i++);
          enc1 = chr1 >> 2;
          enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
          enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
          enc4 = chr3 & 63;
          if (isNaN(chr2)) {
              enc3 = enc4 = 64;
          } else if (isNaN(chr3)) {
              enc4 = 64;
          }
          output = output +
              _keyStr.charAt(enc1) + _keyStr.charAt(enc2) +
              _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
      }
      return output;
  }

  this.decode = function(input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
      while (i < input.length) {
          enc1 = _keyStr.indexOf(input.charAt(i++));
          enc2 = _keyStr.indexOf(input.charAt(i++));
          enc3 = _keyStr.indexOf(input.charAt(i++));
          enc4 = _keyStr.indexOf(input.charAt(i++));
          chr1 = (enc1 << 2) | (enc2 >> 4);
          chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
          chr3 = ((enc3 & 3) << 6) | enc4;
          output = output + String.fromCharCode(chr1);
          if (enc3 != 64) {
              output = output + String.fromCharCode(chr2);
          }
          if (enc4 != 64) {
              output = output + String.fromCharCode(chr3);
          }
      }
      output = _utf8_decode(output);
      return output;
  }

  var _utf8_encode = function(string) {
      string = string.replace(/\r\n/g, "\n");
      var utftext = "";
      for (var n = 0; n < string.length; n++) {
          var c = string.charCodeAt(n);
          if (c < 128) {
              utftext += String.fromCharCode(c);
          } else if ((c > 127) && (c <2048)) {
              utftext += String.fromCharCode((c >> 6) | 192);
              utfText += String.fromCharCode((c & 63) | 128);
          } else {
              utftext += String.fromCharCode((c >> 12) | 224);
              utftext += String.fromCharCode(((c >> 6) & 63) | 128);
              utftext += String.fromCharCode((c & 63) | 128);
          }
      }
      return utftext;
  }

  // private method for UTF-8 decoding  
  var _utf8_decode = function (utftext) {
      var string = "";
      var i = 0;
      var c = 0;
      var c1 = 0;
      var c2 = 0;
      while (i < utftext.length) {    
          c = utftext.charCodeAt(i);
          if (c < 128) {
              string += String.fromCharCode(c);
              i++;
          } else if ((c > 191) && (c < 224)) {
              c1 = utftext.charCodeAt(i + 1);
              string += String.fromCharCode(((c & 31) << 6) | (c1 & 63));
              i += 2;
          } else {
              c1 = utftext.charCodeAt(i + 1);
              c2 = utftext.charCodeAt(i + 2);
              string += String.fromCharCode(((c & 15) << 12) | ((c1 & 63) << 6) | (c2 & 63));
              i += 3;
          }
      }
      return string;
  }
}

